import http from "./http_common";

class ConsentService {
    queryString(payload) {
        return Object.keys(payload)
            .map((key) => (key && payload[key]) ? key + "=" + payload[key] : '')
            .join("&");
    }

    GetPatientConsent(payload) {
        return http.post(`/PatientConsentDetails/send-patient-consent`, payload);
    }

    consentpost(data) {
        return http.post(`PatientConsentDetails/save`, data);
    }

    consentPostFromInviteLink(data) {
        return http.post(`PatientConsentDetails/save-from-invite-link`, data);
    }

    getconsentFilter(payload) {
        var queryString = this.queryString(payload);
        return http.get(`PatientConsentDetails/list/filter?${queryString}`);
    }

    getconsentFilterForLink(payload) {
        var queryString = this.queryString(payload);
        return http.get(`PatientConsentDetails/list/consentDetails?${queryString}`);
    }

}

export default new ConsentService();